export const downloadBlob = (blob: Blob, fileName = 'download') => {
  if (!(blob instanceof Blob) || blob.size === 0) {
    return;
  }
  // extract the clean MIME type (without any parameters)
  const mime = blob.type.split(';')[0].trim();
  // map common MIME types to known extensions
  const mimeToExt: Record<string, string> = {
    'application/pdf': 'pdf',
    'text/csv': 'csv',
    'application/csv': 'csv',
    'application/vnd.ms-excel': 'csv',
    'application/zip': 'zip',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  };

  // derive the extension: if it's not in the map, take the part after the '/'
  let ext = mimeToExt[mime];
  if (!ext) {
    const subtype = mime.split('/')[1] || '';
    // remove any non-alphanumeric characters
    ext = subtype.replace(/[^a-z0-9]/gi, '').toLowerCase();
  }

  // remove any existing extension from fileName
  const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, '');
  const computedFileName = ext ? `${fileNameWithoutExt}.${ext}` : fileName;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = computedFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export function downloadFile(url: string, fileName?: string) {
  if (!url) {
    return;
  }

  const link = document.createElement('a');
  link.href = url;

  link.download = fileName || '';
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  document.body.removeChild(link);
}
